export const MODERATOR_MESSAGE_FIELD_NAME_DEFAULT = 'message';
